import { HtmlHTMLAttributes, PropsWithChildren } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import AuthenticatedPage from './AuthenticatedPage';
import BasicPage from './BasicPage';

export const CommunityWrapper = ({
  children,
  ...props
}: PropsWithChildren<HtmlHTMLAttributes<HTMLDivElement>>) => {
  const { isAuthenticated } = useAuth0();
  const Wrapper = isAuthenticated ? AuthenticatedPage : BasicPage;

  return <Wrapper {...props}>{children}</Wrapper>;
};
